import axios from "axios";
import Config from "../../../config";

const v2_actionEditLeadStatus = (statusId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/lead-status/${statusId}/editar`,
        data
    });
};

export default v2_actionEditLeadStatus;
